import { render, staticRenderFns } from "./ListGroupTest.vue?vue&type=template&id=0abb680e"
import script from "./ListGroupTest.vue?vue&type=script&lang=js"
export * from "./ListGroupTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports